(function () {
  if (window.elvaraMeta) return;
  const pixelId = "924085067436347";
  const source = "https://connect.facebook.net/en_US/fbevents.js";
  const storageKey = "elvara_meta_events_v1";
  const totals = Object.freeze({
    "49065432252601": 214,
    "49070438940857": 299,
    "49143789519033": 199,
    "49207485890745": 299,
    "49143797678265": 349,
  });
  const hairVariants = new Set(["49143789519033", "49207485890745", "49143797678265"]);
  let marketingAllowed = false;
  let pixelReady = false;

  function read() {
    try {
      const raw = window.sessionStorage.getItem(storageKey);
      if (!raw) return { version: 1, initiate: {}, purchase: {} };
      const state = JSON.parse(raw);
      if (state.version !== 1 || !state.initiate || !state.purchase) throw new Error("invalid_meta_state");
      return state;
    } catch {
      return { version: 1, initiate: {}, purchase: {} };
    }
  }

  function write(state) {
    try {
      const serialized = JSON.stringify(state);
      window.sessionStorage.setItem(storageKey, serialized);
      return window.sessionStorage.getItem(storageKey) === serialized;
    } catch { return false; }
  }

  function validRequestId(value) { return /^[a-zA-Z0-9_-]{16,128}$/.test(value || ""); }

  function queue(kind, requestId, variantId) {
    if (!validRequestId(requestId) || !Object.hasOwn(totals, String(variantId))) return;
    const state = read();
    if (state[kind][requestId]?.status === "sent") return;
    state[kind][requestId] = { variantId: String(variantId), status: marketingAllowed && pixelReady ? "sent" : "pending" };
    if (!write(state)) return;
    if (marketingAllowed && pixelReady) send(kind, requestId, String(variantId));
  }

  function send(kind, requestId, variantId) {
    const eventName = kind === "purchase" ? "Purchase" : "InitiateCheckout";
    const value = totals[variantId];
    const payload = { value, currency: "MAD",
      ...(hairVariants.has(variantId) ? { content_type: "product", content_ids: [variantId],
        contents: [{ id: variantId, quantity: 1, item_price: value }] } : {}) };
    window.fbq("trackSingle", pixelId, eventName, payload, { eventID: requestId });
  }

  function drain() {
    const state = read();
    const pending = [];
    for (const kind of ["initiate", "purchase"]) {
      for (const [requestId, event] of Object.entries(state[kind])) {
        if (event.status !== "pending" || !Object.hasOwn(totals, event.variantId)) continue;
        event.status = "sent";
        pending.push([kind, requestId, event.variantId]);
      }
    }
    if (!write(state)) return;
    for (const event of pending) send(...event);
  }

  function loadPixel() {
    if (pixelReady || !marketingAllowed) return;
    if (!window.fbq) {
      const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
      fbq.push = fbq; fbq.loaded = true; fbq.version = "2.0"; fbq.queue = [];
      window.fbq = fbq; window._fbq = fbq;
      const script = document.createElement("script");
      script.async = true; script.src = source;
      const first = document.getElementsByTagName("script")[0];
      first.parentNode.insertBefore(script, first);
    }
    window.fbq("init", pixelId);
    // Keep Meta's automatic form scanning, button inference, and product-page
    // metadata extraction disabled. ELVARA sends only the explicit contract.
    window.fbq("set", "autoConfig", false, pixelId);
    window.fbq("trackSingle", pixelId, "PageView");
    window.fbq("trackSingle", pixelId, "ViewContent", { content_name: "ELVARA", content_type: "product", currency: "MAD" });
    pixelReady = true;
    drain();
  }

  function activate() {
    try {
      marketingAllowed = window.Shopify?.customerPrivacy?.marketingAllowed() === true;
    } catch { marketingAllowed = false; }
    if (marketingAllowed) loadPixel();
  }

  function cookie(name) {
    const prefix = `${name}=`;
    return String(document.cookie || "").split(";").map(value => value.trim()).find(value => value.startsWith(prefix))?.slice(prefix.length);
  }

  function serverContext() {
    if (!marketingAllowed) return { marketing_allowed: false };
    let fbc = cookie("_fbc");
    if (!fbc) {
      const fbclid = new URL(window.location.href).searchParams.get("fbclid");
      if (fbclid && /^[A-Za-z0-9._-]{1,128}$/.test(fbclid)) fbc = `fb.1.${Date.now()}.${fbclid}`;
    }
    return {
      marketing_allowed: true,
      ...(cookie("_fbp") ? { fbp: cookie("_fbp") } : {}),
      ...(fbc ? { fbc } : {}),
      client_user_agent: window.navigator.userAgent,
    };
  }

  window.elvaraMeta = {
    initiateCheckout(requestId, variantId) { queue("initiate", requestId, variantId); },
    purchase(requestId, variantId) { queue("purchase", requestId, variantId); },
    serverContext,
  };

  document.addEventListener("visitorConsentCollected", activate);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], error => { if (!error) activate(); });
  }
})();
